import { React, useState, useEffect } from 'react';
import './header.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../../../Redux/actions';
import { ReactComponent as Notification } from '../../../assets/images/svgIcons/ic_bell.svg';
import { ReactComponent as Chat } from '../../../assets/images/svgIcons/ic_chat.svg';
import { ReactComponent as Setting } from '../../../assets/images/svgIcons/ic_setting.svg';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaRightFromBracket } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserId, getUserName } from '../../../../Redux/selecters';
import ApiService from '../../../services/apiService';
import Select from 'react-select';

const AdminHeader = () => {
  const [headerText, setHeaderText] = useState('Dashboard');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userName = useSelector(getUserName);
  const userId = useSelector(getUserId);
  const [branches, setBranches] = useState([]);
  let selectedbranch = localStorage.getItem('selectedBranch');
  const [selectedBranch, setSelectedBranch] = useState([]);
  useEffect(() => {
    const menuRegex = /^\/admin\/menu\/[^\/]+\/[^\/]+$/;
    const updateRegex = /^\/admin\/master\/Update\/(.+)$/;
    const { pathname } = location;
    if (pathname === '/admin/menu') {
      setHeaderText(`${t('Menu')}`);
    } else if (pathname === '/admin/orders') {
      setHeaderText(`${t('Orders')}`);
    } else if (pathname.includes('/admin/order/')) {
      setHeaderText(`${t('Orders')}`);
    } else if (pathname === '/home') {
      setHeaderText(`${t('Dashboard')}`);
    } else if (pathname === '/admin/ordersDND') {
      setHeaderText(`${t('Drag_and_Drop')}`);
    } else if (pathname === '/admin/master/Create') {
      setHeaderText(`${t('Create')} ${t('Item')}`);
    } else if (pathname === '/admin/master/promotion') {
      setHeaderText(`${t('Promotion Master')}`);
    } else if (pathname === '/admin/master/ItemMaster/Create') {
      setHeaderText(`${t('Create')} ${t('Item')}`);
    } else if (pathname === '/admin/CustomerList') {
      setHeaderText(`${t('Customers')} ${t('List')}`);
    } else if (pathname === '/admin/AddCustomer') {
      setHeaderText(`${t('Add')} ${t('Customers')}`);
    } else if (pathname === '/admin/Company/Create') {
      setHeaderText(`${t('Company')}`);
    } else if (pathname === '/admin/Company/Branch/Create') {
      setHeaderText(`${t('Branches')}`);
    } else if (pathname === '/admin/Company') {
      setHeaderText(`${t('Company')}`);
    } else if (pathname === '/admin/employee') {
      setHeaderText(`${t('Employees')}`);
    } else if (pathname === '/admin/Addemployee') {
      setHeaderText(`${t('Employees')}`);
    } else if (pathname === '/admin/itemMaster/modifier') {
      setHeaderText(`${t('Modifiers')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/addsOns') {
      setHeaderText(`${t('Addons')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/Combos') {
      setHeaderText(`${t('Combo')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/addCategory') {
      setHeaderText(`${t('Item')} ${t('Category')}`);
    } else if (pathname === '/admin/itemMaster/subCategory') {
      setHeaderText(`${t('Item')} ${t('Subcategory')}`);
    } else if (pathname === '/admin/master/Variants') {
      setHeaderText(`${t('Item')} ${t('Variants')}`);
    } else if (pathname === '/admin/itemMaster/UploadFile') {
      setHeaderText('CSV File Management');
    } else if (pathname === '/admin/posting') {
      setHeaderText('Posting');
    } else if (pathname === '/admin/master/CurrencyManagement') {
      setHeaderText(`${t('Currency')} ${t('Masters')}`);
    } else if (pathname === '/admin/Delivery/Create') {
      setHeaderText('Delivery Platforms');
    } else if (pathname === '/admin/master/TaxManagement') {
      setHeaderText(`${t('Tax')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/bulkItemselse') {
      setHeaderText(`${t('Bulk')} ${t('Upload')}`);
    } else if (pathname === '/admin/master/Table') {
      setHeaderText(`${t('Table')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/Discount') {
      setHeaderText(`${t('Discount')} ${t('Masters')}`);
    } else if (pathname === '/admin/Payment') {
      setHeaderText(`${t('Payments')}`);
    } else if (pathname === '/admin/Payment') {
      setHeaderText(`${t('Payments')}`);
    } else if (pathname === '/admin/master/Kitchen') {
      setHeaderText(`${t('Kitchen')} ${t('Masters')}`);
    } else if (menuRegex.test(pathname)) {
      setHeaderText(`${t('Item')} ${t('Masters')}`);
    } else if (updateRegex.test(pathname)) {
      setHeaderText(`${t('Update')} ${t('Item')}`);
    } else if (pathname === '/admin/Reports/home') {
      setHeaderText(`${t('Total_Sale_Report')}`);
    } else if (pathname === '/admin/Reports/SaleDetails') {
      setHeaderText(`${t('Sales')} ${t('Details')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Order') {
      setHeaderText(`${t('Orders')} ${t('Details')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/OrderHistory') {
      setHeaderText(`${t('Orders')} ${t('History')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/TotalSale') {
      setHeaderText(`${t('Monthly')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Cash') {
      setHeaderText(`${t('Cash_In')} ${t('Cash_Out')}  ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/Table') {
      setHeaderText(`${t('Table')}  ${t('Reports')}`);
    } else if (pathname === '/admin/master/area') {
      setHeaderText(`${t('Table')} ${t('Area')}  ${t('Masters')}`);
    } else if (pathname === '/admin/master/paymentMethod') {
      setHeaderText(`${t('Payments')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/CounterMaster') {
      setHeaderText(`${t('Counter')} ${t('Masters')}`);
    } else if (pathname === '/admin/itemMaster/Variants') {
      setHeaderText(`${t('Variants')} ${t('Masters')}`);
    } else if (pathname === '/admin/Setting/Profile') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Notification') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Currency') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Tax') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Setting/Theme') {
      setHeaderText(`${t('Setting')}`);
    } else if (pathname === '/admin/Reports/Dashboard') {
      setHeaderText(`${t('Reports')} ${t('Dashboard')}`);
    } else if (pathname === '/admin/Reports/XReport') {
      setHeaderText(`${t('X_Report')}`);
    } else if (pathname === '/admin/Reports/ZReport') {
      setHeaderText(`${t('Z_Report')}`);
    } else if (pathname === '/admin/Reports/CustomerOrders') {
      setHeaderText(`${t('Customers')} ${t('Orders')} ${t('Count')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/List') {
      setHeaderText(`${t('Reports')} ${t('List')}`);
    } else if (pathname === '/admin/Master/List') {
      setHeaderText(`${t('Masters')} ${t('List')}`);
    } else if (pathname === '/admin/Reports/ItemSale') {
      setHeaderText(`${t('Sales')} ${t('Detail')} `);
    } else if (pathname === '/admin/Reports/CategorySale') {
      setHeaderText(`${t('Category')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/category') {
      setHeaderText(`${t('Sale')} ${t('Summary')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/cashier') {
      setHeaderText(`${t('Cashier')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/PaymentMethod') {
      setHeaderText(`${t('Payments')} ${t('Type')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/SaleTax') {
      setHeaderText(`${t('Sales')} ${t('Tax')} ${t('Reports')}`);
    } else if (pathname === '/admin/master/terminal') {
      setHeaderText(`${t('Terminal')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/marchaint') {
      setHeaderText(`${t('Merchaint')} ${t('Masters')}`);
    } else if (pathname === '/admin/master/QR') {
      setHeaderText(`${t('QR')} ${t('Masters')}`);
    } else if (pathname === '/admin/Reports/ProfitMargin') {
      setHeaderText(`${t('Profit')} ${t('Margin')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/BestWorstSales') {
      setHeaderText(`${t('Best')} & ${t('Least')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/FlashSummary') {
      setHeaderText(`${t('Flash')} ${t('Sale')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/SalesByHour') {
      setHeaderText(`${t('Sales')} ${t('By')} ${t('Hour')} ${t('Reports')}`);
    } else if (pathname === '/admin/Reports/DailySalesSummary') {
      setHeaderText(`${t('Daily')} ${t('Sales')} ${t('Reports')}`);
    } else if (pathname === '/admin/master/bulkItems') {
      setHeaderText(`${t('Item')} ${t('Bulk_Upload')}`);
    } else if (pathname === '/admin/Reports/PurchaseTax') {
      setHeaderText(`Purchase ${t('Tax')} ${t('Reports')}`);
    } else {
      setHeaderText(`${t('Dashboard')}`);
    }
  }, [location]);

  //   useEffect(() => {
  //     getBranches();
  //   }, [selectedBranch]);

  const [formData, setFormData] = useState({
    branchId: selectedbranch,
  });

  //   const getBranches = async () => {
  //     try {
  //       const apiService = new ApiService();
  //       let res = await apiService.get('GET_BRANCH');
  //       setFormData({ ...formData, branchId: { label: res.data.result[0]?.branchName, value: res.data.result[0] } });
  //       localStorage.setItem('selectedBranch', res.data.result[0]?.id || '0');
  //       setBranches([{ id: 0, branchName: 'All' }, ...res.data.result]);
  //     } catch (error) {
  //       console.error('Error fetching branches:', error);
  //     }
  //   };
  const handleOut = () => {
    dispatch(logout());
    localStorage.clear();
    // navigate('/');
    window.location.href = 'https://app.pro360erp.com/';
  };

  const handleBranchChange = (selectedOption) => {
    localStorage.setItem('selectedBranch', selectedOption?.value?.id || '0');
    localStorage.setItem('userID', userId);
    setFormData({ ...formData, branchId: selectedOption });
  };
  const handleSwitchtoCashier = () => {
    window.open('/cashier/CounterSelection', '_blank');
  };
  return (
    <nav class="navbar-expand-lg  mainBG ">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse d-flex justify-content-between" id="navbarSupportedContent">
          <div className="dnon">
            <div className="Headtxt">{headerText}</div>
            <div className="headtxt2"></div>
          </div>
          <div className="d-flex gap-2 pad">
            <div className="gap-2 d-flex">
              {/* <Select
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                // className='w-50'
                id="branchSelect"
                value={{ value: formData?.branchId?.value, label: formData?.branchId === '0' ? 'All' : formData?.branchId?.label }}
                onChange={handleBranchChange}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                menuShouldScrollIntoView={false}
                options={branches?.map((branch) => ({ value: branch, label: branch.branchName }))}
              /> */}
              {/* <div className="addbrnchbtn d-flex  gap-3" onClick={handleSwitchtoCashier}>
                <div className="center">PO {t('sales')}</div>
                <FaRightFromBracket className="center mt-2" />
              </div> */}
              <div className="iconBG">
                <Notification />
              </div>
              <div className="iconBG">
                <Chat />
              </div>
              {/* <div className='iconBG'><Setting /></div> */}
            </div>
            <div className="profilebox dropdown">
              {userName || 'Admin'}
              <div className="dropdown-content-stats pt-1">
                <Link to="/admin/Setting/Currency" className="p-2">
                  {t('setting')}
                </Link>
                <Link onClick={handleOut} className="p-2">
                  {t('Logout')}
                </Link>
              </div>
            </div>
            <div className="adminprofileimgbox boxicon">
              {/* <img src={Profile} alt='profile' className='adminImg' /> */}
              <Setting className="" size={25} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

// export default AdminHeader

const mapStatetoProps = (state) => state;
// const mapDispatchToProps = (dispatch) => ({
//   toggleDark: (payload) => dispatch(cure()),
// });
export default connect(mapStatetoProps)(AdminHeader);
